/*
 * @Author: Yun
 * @Date: 2023-11-29 15:52:26
 * @Last Modified by: Yun
 * @Last Modified time: 2023-12-29 17:02:18
 */
import React, { useState, useEffect, useRef, useImperativeHandle } from 'react'
import firstLogo from '@icons/cgtn.jpg'
import gsap from 'gsap'
import firstTitle from '@images/firstPage/title.jpg'
import share from '@icons/share.png'
import fb from '@images/footer/fb.png'
import x from '@images/footer/x.png'
import wb from '@images/footer/wb.png'
import $ from 'jquery'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import './index.less'
// let current = []

gsap.registerPlugin(ScrollTrigger)
const PREFIX = 'first-page-mobile'
const FirstPage = () => {
    useEffect(() => {
        mobileDemoTimeline()
        // console.log(window.addEventListener('scroll', handleScroll))
    }, [])
    // const handleScroll = () => {
    //     const scrollTop = window.pageYOffset
    //     if (scrollTop > 0) {
    //         return 1
    //     } else {
    //         return 0
    //     }
    // }
    const mobileDemoTimeline = () => {
        let tl = gsap.timeline()

        // tl.to('body', { overflow: 'hidden' })
        for (let i = 0; i < 10; i++) {
            // console.log('iiiiiiiiiiiiiiiiiiiiii', i)
            tl.to(`.top-item-${i}`, { duration: 0.15, opacity: 0 })
                // .addLabel(`top-${i}`)
                .to(`.top-count-${i}`, { duration: 0.15, opacity: 0 })
                // .addLabel(`top-count-item-${i}`)
                // .to(`.bg-item-${i}`, { duration: 0.1, opacity: 1 })
                // .addLabel(`bg-${i}`)
                .to(`.bottom-item-${i}`, { duration: 0.15, opacity: 1 })
            // .addLabel(`bottom-${i}`)
            // .to(`keywords-${i}`, { duration: 0.1, opacity: 1 })
            // .addLabel(`bottom-key-${i}`)
        }
        tl.to('body', { overflow: 'auto' })
        // tl.to(`.keywords-9`, { duration: 0.1, opacity: 1 })

        // tl.addLabel('start')
        // add animations and labels to the timeline

        // tl.addLabel('end')

        let st = ScrollTrigger.create({
            trigger: '.demo1-mobile',
            start: 'top top',
            end: '+=150',
            pin: '.demo1-mobile',
            // once: true,
            // scrub: 1,
            // snap: 0,
            // pinSpacer: '',
            // pinSpacing: false,
            animation: tl,
        })
    }

    const topCurrentList = {
        detial: [
            {
                count: 211,
                backgroundColor: '#6648d1',
                className: 'top-item-0',
            },
            {
                count: 145,
                backgroundColor: '#a862dc',
                className: 'top-item-1',
            },
            {
                count: 120,
                backgroundColor: '#d55e53',
                className: 'top-item-2',
            },
            {
                count: 100,
                backgroundColor: '#bb9149',
                className: 'top-item-3',
            },
            {
                count: 99,
                backgroundColor: '#ebb62a',
                className: 'top-item-4',
            },
            {
                count: 77,
                backgroundColor: '#0c9ab3',
                className: 'top-item-5',
            },
            {
                count: 60,
                backgroundColor: '#027fd3',
                className: 'top-item-6',
            },
            {
                count: 56,
                backgroundColor: '#02cdda',
                className: 'top-item-7',
            },
            {
                count: 54,
                backgroundColor: '#77d495',
                className: 'top-item-8',
            },
            {
                count: 51,
                backgroundColor: '#1ca970',
                className: 'top-item-9',
            },
        ],
    }

    const bottomDivList = [
        {
            keyword1: [
                {
                    count: 13,
                    backgroundColor: '#6648d1',
                    className: 'bottom-item-0',
                },
                {
                    count: 21,
                    backgroundColor: '#a862dc',
                    className: 'bottom-item-1',
                },
                {
                    count: 17,
                    backgroundColor: '#d55e53',
                    className: 'bottom-item-2',
                },
                {
                    count: 3,
                    backgroundColor: '#bb9149',
                    className: 'bottom-item-3',
                },
                {
                    count: 5,
                    backgroundColor: '#e3d0b4',
                    className: 'bottom-item-4',
                },
                {
                    count: 2,
                    backgroundColor: '#0c9ab3',
                    className: 'bottom-item-5',
                },
                {
                    count: 5,
                    backgroundColor: '#027fd3',
                    className: 'bottom-item-6',
                },
                {
                    count: 7,
                    backgroundColor: '#02cdda',
                    className: 'bottom-item-7',
                },
                {
                    count: 4,
                    backgroundColor: '#77d495',
                    className: 'bottom-item-8',
                },
                {
                    count: 0,
                    backgroundColor: '#1ca970',
                    className: 'bottom-item-9',
                },
            ],
            keyword2: [
                {
                    count: 25,
                    backgroundColor: '#6648d1',
                    className: 'bottom-item-0',
                },
                {
                    count: 4,
                    backgroundColor: '#a862dc',
                    className: 'bottom-item-1',
                },
                {
                    count: 13,
                    backgroundColor: '#d55e53',
                    className: 'bottom-item-2',
                },
                {
                    count: 9,
                    backgroundColor: '#bb9149',
                    className: 'bottom-item-3',
                },
                {
                    count: 9,
                    backgroundColor: '#e3d0b4',
                    className: 'bottom-item-4',
                },
                {
                    count: 8,
                    backgroundColor: '#0c9ab3',
                    className: 'bottom-item-5',
                },
                {
                    count: 5,
                    backgroundColor: '#027fd3',
                    className: 'bottom-item-6',
                },
                {
                    count: 7,
                    backgroundColor: '#02cdda',
                    className: 'bottom-item-7',
                },
                {
                    count: 4,
                    backgroundColor: '#77d495',
                    className: 'bottom-item-8',
                },
                {
                    count: 0,
                    backgroundColor: '#1ca970',
                    className: 'bottom-item-9',
                },
            ],
            keyword3: [
                {
                    count: 15,
                    backgroundColor: '#6648d1',
                    className: 'bottom-item-0',
                },
                {
                    count: 16,
                    backgroundColor: '#a862dc',
                    className: 'bottom-item-1',
                },
                {
                    count: 0,
                    backgroundColor: '#d55e53',
                    className: 'bottom-item-2',
                },
                {
                    count: 6,
                    backgroundColor: '#bb9149',
                    className: 'bottom-item-3',
                },
                {
                    count: 5,
                    backgroundColor: '#e3d0b4',
                    className: 'bottom-item-4',
                },
                {
                    count: 5,
                    backgroundColor: '#0c9ab3',
                    className: 'bottom-item-5',
                },
                {
                    count: 6,
                    backgroundColor: '#027fd3',
                    className: 'bottom-item-6',
                },
                {
                    count: 9,
                    backgroundColor: '#02cdda',
                    className: 'bottom-item-7',
                },
                {
                    count: 3,
                    backgroundColor: '#77d495',
                    className: 'bottom-item-8',
                },
                {
                    count: 3,
                    backgroundColor: '#1ca970',
                    className: 'bottom-item-9',
                },
            ],
            keyword4: [
                {
                    count: 23,
                    backgroundColor: '#6648d1',
                    className: 'bottom-item-0',
                },
                {
                    count: 8,
                    backgroundColor: '#a862dc',
                    className: 'bottom-item-1',
                },
                {
                    count: 12,
                    backgroundColor: '#d55e53',
                    className: 'bottom-item-2',
                },
                {
                    count: 11,
                    backgroundColor: '#bb9149',
                    className: 'bottom-item-3',
                },
                {
                    count: 8,
                    backgroundColor: '#e3d0b4',
                    className: 'bottom-item-4',
                },
                {
                    count: 4,
                    backgroundColor: '#0c9ab3',
                    className: 'bottom-item-5',
                },
                {
                    count: 6,
                    backgroundColor: '#027fd3',
                    className: 'bottom-item-6',
                },
                {
                    count: 6,
                    backgroundColor: '#02cdda',
                    className: 'bottom-item-7',
                },
                {
                    count: 3,
                    backgroundColor: '#77d495',
                    className: 'bottom-item-8',
                },
                {
                    count: 6,
                    backgroundColor: '#1ca970',
                    className: 'bottom-item-9',
                },
            ],
            keyword5: [
                {
                    count: 13,
                    backgroundColor: '#6648d1',
                    className: 'bottom-item-0',
                },
                {
                    count: 5,
                    backgroundColor: '#a862dc',
                    className: 'bottom-item-1',
                },
                {
                    count: 1,
                    backgroundColor: '#d55e53',
                    className: 'bottom-item-2',
                },
                {
                    count: 8,
                    backgroundColor: '#bb9149',
                    className: 'bottom-item-3',
                },
                {
                    count: 1,
                    backgroundColor: '#e3d0b4',
                    className: 'bottom-item-4',
                },
                {
                    count: 1,
                    backgroundColor: '#0c9ab3',
                    className: 'bottom-item-5',
                },
                {
                    count: 2,
                    backgroundColor: '#027fd3',
                    className: 'bottom-item-6',
                },
                {
                    count: 5,
                    backgroundColor: '#02cdda',
                    className: 'bottom-item-7',
                },
                {
                    count: 3,
                    backgroundColor: '#77d495',
                    className: 'bottom-item-8',
                },
                {
                    count: 15,
                    backgroundColor: '#1ca970',
                    className: 'bottom-item-9',
                },
            ],
            keyword6: [
                {
                    count: 14,
                    backgroundColor: '#6648d1',
                    className: 'bottom-item-0',
                },
                {
                    count: 27,
                    backgroundColor: '#a862dc',
                    className: 'bottom-item-1',
                },
                {
                    count: 2,
                    backgroundColor: '#d55e53',
                    className: 'bottom-item-2',
                },
                {
                    count: 11,
                    backgroundColor: '#bb9149',
                    className: 'bottom-item-3',
                },
                {
                    count: 3,
                    backgroundColor: '#e3d0b4',
                    className: 'bottom-item-4',
                },
                {
                    count: 2,
                    backgroundColor: '#0c9ab3',
                    className: 'bottom-item-5',
                },
                {
                    count: 3,
                    backgroundColor: '#027fd3',
                    className: 'bottom-item-6',
                },
                {
                    count: 4,
                    backgroundColor: '#02cdda',
                    className: 'bottom-item-7',
                },
                {
                    count: 6,
                    backgroundColor: '#77d495',
                    className: 'bottom-item-8',
                },
                {
                    count: 5,
                    backgroundColor: '#1ca970',
                    className: 'bottom-item-9',
                },
            ],
            keyword7: [
                {
                    count: 0,
                    backgroundColor: '#6648d1',
                    className: 'bottom-item-0',
                },
                {
                    count: 0,
                    backgroundColor: '#a862dc',
                    className: 'bottom-item-1',
                },
                {
                    count: 2,
                    backgroundColor: '#d55e53',
                    className: 'bottom-item-2',
                },
                {
                    count: 0,
                    backgroundColor: '#bb9149',
                    className: 'bottom-item-3',
                },
                {
                    count: 0,
                    backgroundColor: '#e3d0b4',
                    className: 'bottom-item-4',
                },
                {
                    count: 0,
                    backgroundColor: '#0c9ab3',
                    className: 'bottom-item-5',
                },
                {
                    count: 0,
                    backgroundColor: '#027fd3',
                    className: 'bottom-item-6',
                },
                {
                    count: 0,
                    backgroundColor: '#02cdda',
                    className: 'bottom-item-7',
                },
                {
                    count: 0,
                    backgroundColor: '#77d495',
                    className: 'bottom-item-8',
                },
                {
                    count: 2,
                    backgroundColor: '#1ca970',
                    className: 'bottom-item-9',
                },
            ],
            keyword8: [
                {
                    count: 15,
                    backgroundColor: '#6648d1',
                    className: 'bottom-item-0',
                },
                {
                    count: 23,
                    backgroundColor: '#a862dc',
                    className: 'bottom-item-1',
                },
                {
                    count: 14,
                    backgroundColor: '#d55e53',
                    className: 'bottom-item-2',
                },
                {
                    count: 8,
                    backgroundColor: '#bb9149',
                    className: 'bottom-item-3',
                },
                {
                    count: 3,
                    backgroundColor: '#e3d0b4',
                    className: 'bottom-item-4',
                },
                {
                    count: 0,
                    backgroundColor: '#0c9ab3',
                    className: 'bottom-item-5',
                },
                {
                    count: 2,
                    backgroundColor: '#027fd3',
                    className: 'bottom-item-6',
                },
                {
                    count: 3,
                    backgroundColor: '#02cdda',
                    className: 'bottom-item-7',
                },
                {
                    count: 4,
                    backgroundColor: '#77d495',
                    className: 'bottom-item-8',
                },
                {
                    count: 9,
                    backgroundColor: '#1ca970',
                    className: 'bottom-item-9',
                },
            ],
            keyword9: [
                {
                    count: 19,
                    backgroundColor: '#6648d1',
                    className: 'bottom-item-0',
                },
                {
                    count: 7,
                    backgroundColor: '#a862dc',
                    className: 'bottom-item-1',
                },
                {
                    count: 17,
                    backgroundColor: '#d55e53',
                    className: 'bottom-item-2',
                },
                {
                    count: 10,
                    backgroundColor: '#bb9149',
                    className: 'bottom-item-3',
                },
                {
                    count: 8,
                    backgroundColor: '#e3d0b4',
                    className: 'bottom-item-4',
                },
                {
                    count: 5,
                    backgroundColor: '#0c9ab3',
                    className: 'bottom-item-5',
                },
                {
                    count: 9,
                    backgroundColor: '#027fd3',
                    className: 'bottom-item-6',
                },
                {
                    count: 2,
                    backgroundColor: '#02cdda',
                    className: 'bottom-item-7',
                },
                {
                    count: 8,
                    backgroundColor: '#77d495',
                    className: 'bottom-item-8',
                },
                {
                    count: 3,
                    backgroundColor: '#1ca970',
                    className: 'bottom-item-9',
                },
            ],
            keyword10: [
                {
                    count: 19,
                    backgroundColor: '#6648d1',
                    className: 'bottom-item-0',
                },
                {
                    count: 4,
                    backgroundColor: '#a862dc',
                    className: 'bottom-item-1',
                },
                {
                    count: 18,
                    backgroundColor: '#d55e53',
                    className: 'bottom-item-2',
                },
                {
                    count: 10,
                    backgroundColor: '#bb9149',
                    className: 'bottom-item-3',
                },
                {
                    count: 17,
                    backgroundColor: '#e3d0b4',
                    className: 'bottom-item-4',
                },
                {
                    count: 20,
                    backgroundColor: '#0c9ab3',
                    className: 'bottom-item-5',
                },
                {
                    count: 7,
                    backgroundColor: '#027fd3',
                    className: 'bottom-item-6',
                },
                {
                    count: 4,
                    backgroundColor: '#02cdda',
                    className: 'bottom-item-7',
                },
                {
                    count: 8,
                    backgroundColor: '#77d495',
                    className: 'bottom-item-8',
                },
                {
                    count: 3,
                    backgroundColor: '#1ca970',
                    className: 'bottom-item-9',
                },
            ],
            keyword11: [
                {
                    count: 20,
                    backgroundColor: '#6648d1',
                    className: 'bottom-item-0',
                },
                {
                    count: 7,
                    backgroundColor: '#a862dc',
                    className: 'bottom-item-1',
                },
                {
                    count: 13,
                    backgroundColor: '#d55e53',
                    className: 'bottom-item-2',
                },
                {
                    count: 18,
                    backgroundColor: '#bb9149',
                    className: 'bottom-item-3',
                },
                {
                    count: 18,
                    backgroundColor: '#e3d0b4',
                    className: 'bottom-item-4',
                },
                {
                    count: 15,
                    backgroundColor: '#0c9ab3',
                    className: 'bottom-item-5',
                },
                {
                    count: 5,
                    backgroundColor: '#027fd3',
                    className: 'bottom-item-6',
                },
                {
                    count: 5,
                    backgroundColor: '#02cdda',
                    className: 'bottom-item-7',
                },
                {
                    count: 4,
                    backgroundColor: '#77d495',
                    className: 'bottom-item-8',
                },
                {
                    count: 2,
                    backgroundColor: '#1ca970',
                    className: 'bottom-item-9',
                },
            ],
            keyword12: [
                {
                    count: 9,
                    backgroundColor: '#6648d1',
                    className: 'bottom-item-0',
                },
                {
                    count: 7,
                    backgroundColor: '#a862dc',
                    className: 'bottom-item-1',
                },
                {
                    count: 9,
                    backgroundColor: '#d55e53',
                    className: 'bottom-item-2',
                },
                {
                    count: 6,
                    backgroundColor: '#bb9149',
                    className: 'bottom-item-3',
                },
                {
                    count: 6,
                    backgroundColor: '#e3d0b4',
                    className: 'bottom-item-4',
                },
                {
                    count: 5,
                    backgroundColor: '#0c9ab3',
                    className: 'bottom-item-5',
                },
                {
                    count: 3,
                    backgroundColor: '#027fd3',
                    className: 'bottom-item-6',
                },
                {
                    count: 2,
                    backgroundColor: '#02cdda',
                    className: 'bottom-item-7',
                },
                {
                    count: 3,
                    backgroundColor: '#77d495',
                    className: 'bottom-item-8',
                },
                {
                    count: 2,
                    backgroundColor: '#1ca970',
                    className: 'bottom-item-9',
                },
            ],
            keyword13: [
                {
                    count: 16,
                    backgroundColor: '#6648d1',
                    className: 'bottom-item-0',
                },
                {
                    count: 6,
                    backgroundColor: '#a862dc',
                    className: 'bottom-item-1',
                },
                {
                    count: 2,
                    backgroundColor: '#d55e53',
                    className: 'bottom-item-2',
                },
                {
                    count: 0,
                    backgroundColor: '#bb9149',
                    className: 'bottom-item-3',
                },
                {
                    count: 4,
                    backgroundColor: '#e3d0b4',
                    className: 'bottom-item-4',
                },
                {
                    count: 8,
                    backgroundColor: '#0c9ab3',
                    className: 'bottom-item-5',
                },
                {
                    count: 7,
                    backgroundColor: '#027fd3',
                    className: 'bottom-item-6',
                },
                {
                    count: 0,
                    backgroundColor: '#02cdda',
                    className: 'bottom-item-7',
                },
                {
                    count: 1,
                    backgroundColor: '#77d495',
                    className: 'bottom-item-8',
                },
                {
                    count: 0,
                    backgroundColor: '#1ca970',
                    className: 'bottom-item-9',
                },
            ],
            keyword14: [
                {
                    count: 10,
                    backgroundColor: '#6648d1',
                    className: 'bottom-item-0',
                },
                {
                    count: 10,
                    backgroundColor: '#a862dc',
                    className: 'bottom-item-1',
                },
                {
                    count: 0,
                    backgroundColor: '#d55e53',
                    className: 'bottom-item-2',
                },
                {
                    count: 0,
                    backgroundColor: '#bb9149',
                    className: 'bottom-item-3',
                },
                {
                    count: 12,
                    backgroundColor: '#e3d0b4',
                    className: 'bottom-item-4',
                },
                {
                    count: 2,
                    backgroundColor: '#0c9ab3',
                    className: 'bottom-item-5',
                },
                {
                    count: 0,
                    backgroundColor: '#027fd3',
                    className: 'bottom-item-6',
                },
                {
                    count: 2,
                    backgroundColor: '#02cdda',
                    className: 'bottom-item-7',
                },
                {
                    count: 3,
                    backgroundColor: '#77d495',
                    className: 'bottom-item-8',
                },
                {
                    count: 1,
                    backgroundColor: '#1ca970',
                    className: 'bottom-item-9',
                },
            ],
        },
    ]

    const bottomObj = {
        keyword1: [73],
        keyword2: [83],
        keyword3: [58],
        keyword4: [87],
        keyword5: [52],
        keyword6: [68],
        keyword7: [4],
        keyword8: [72],
        keyword9: [87],
        keyword10: [108],
        keyword11: [106],
        keyword12: [22],
    }

    const topNameList = [
        { name: 'Development', color: '#6648d1' },
        { name: 'People', color: '#a862dc' },
        { name: 'Culture', color: '#d55e53' },
        { name: 'Industry', color: '#bb9149' },
        { name: 'Innovation', color: '#ebb62a' },
        { name: 'Technology', color: '#0c9ab3' },
        { name: 'Economy', color: '#027fd3' },
        { name: 'Modernization', color: '#02cdda' },
        { name: 'Reform', color: '#77d495' },
        { name: 'Ecology', color: '#1ca970' },
    ]

    const bottomNameList = [
        { position: 'Tianjin', num: 'Feb.' },
        { position: 'Hunan', num: 'Mar.' },
        { position: 'Chongqing', num: 'Apr.' },
        { position: 'Shandong', num: 'May' },
        { position: 'Qinghai', num: 'Jun.' },
        { position: 'Ningxia', num: 'Jun.' },
        { position: 'Shaanxi', num: 'Sept.' },
        { position: 'Gansu', num: 'Sept.' },
        { position: 'Fujian', num: 'Oct.' },
        { position: 'Anhui', num: 'Oct.' },
        { position: 'Hubei', num: 'Nov.' },
        { position: 'Hainan', num: 'Dec.' },
        { position: 'Macao', num: 'Dec.' },
        { position: 'Military', num: 'Feb., Apr., Oct., Nov., Dec.' },
    ]

    const BackgroundColorDivs = ({ data }) => {
        return data.detial.map((item, index) => (
            <div
                key={index}
                style={{
                    // transform: 'scaleX(-1)',
                    height: '8.5%',
                    margin: '0 0.75%',
                    display: 'flex',
                    flexWrap: 'wrap',
                    flexDirection: 'column',
                }}
            >
                {Array.from({ length: item.count }).map((_, subIndex) => (
                    <div
                        className={item.className}
                        style={{
                            display: 'inline-block',
                            backgroundColor: item.backgroundColor,
                            height: '.75vh',
                            width: '.75vh',
                            margin: '.045vh',
                            borderRadius: '50%',
                            display: 'inline-block',
                            border: 'none',
                        }}
                    ></div>
                ))}
                <div
                    className={`top-count-${index}`}
                    style={{
                        // transform: 'scaleY(-1)',
                        textAlign: 'center',
                        fontSize: '2.4vw',
                        opacity: 1,
                        fontWeight: '600',
                        marginLeft: '1vw',
                    }}
                >
                    {item.count}
                </div>
            </div>
        ))
    }

    const KeywordDivs = ({ data }) => {
        return data.map((dataObject, dataIndex) =>
            // 遍历 dataObject 中的每个关键词及其对应的数组
            Object.keys(dataObject).map((keyword, keywordIndex) => (
                <div
                    key={`${dataIndex}-${keywordIndex}`}
                    className={`keyword-container ${keyword}`}
                    style={{
                        transform: 'scaleX(-1)',
                        flex: '1',
                        marginBottom: '4.5vw',
                        flexWrap: 'wrap',
                        display: 'flex',
                        flexDirection: 'column',
                        width: '10vw',
                        marginLeft: '60vw',
                        height: '5.6vw',
                    }}
                >
                    {dataObject[keyword].map((item, itemIndex) =>
                        Array.from({ length: item.count }).map((_, countIndex) => (
                            <div
                                key={`${dataIndex}-${keywordIndex}-${itemIndex}-${countIndex}`}
                                style={{
                                    backgroundColor: item.backgroundColor,
                                    display: 'inline-block',
                                    height: '.75vh',
                                    width: '.75vh',
                                    margin: '.045vh',
                                    borderRadius: '50%',
                                    opacity: 0,
                                }}
                                className={item.className}
                            ></div>
                        ))
                    )}
                    {/* <div
                        className="keywords-9"
                        style={{
                            transform: 'scaleX(-1)',
                            textAlign: 'center',
                            fontSize: '1.5vh',
                            opacity: 1,
                            fontWeight: '600',
                            flex: 'none',
                        }}
                    >
                        {bottomObj[keyword]}
                    </div> */}
                </div>
            ))
        )
    }

    return (
        <section className={PREFIX}>
            <div className="demo1-mobile">
                <div
                    className="demo_wrapper"
                    style={{
                        overflow: 'auto',
                        height: '169vw',
                        width: '100%',
                        paddingTop: '34.4vw',
                        scrollbarWidth: 'none',
                    }}
                >
                    <div className={`${PREFIX}-title`}>
                        <div className="title-word">
                            <div className="title-pt1">Keywords</div>
                            <div className="title-pt2">
                                from official reports on Xi Jinping's tours in China in 2024
                                indicate his priorities
                            </div>
                        </div>
                        {/* <div className="title-pt4">
                            Word frequency is based on the 49 official Chinese news reports on
                            President Xi's tours in China in 2024.
                        </div> */}
                        <div
                            style={{
                                display: 'flex',
                                // flexDirection: 'column',
                                height: '162vw',
                                position: 'relative',
                                width: '80vw',
                            }}
                        >
                            <div
                                style={{
                                    fontSize: '2.6vw',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    height: '162vw',
                                    position: 'absolute',
                                    top: '-3vw',
                                    width: '36vw',
                                }}
                            >
                                {topNameList.map((item, index) => {
                                    return (
                                        <div
                                            style={{
                                                flex: '1',
                                                textAlign: 'start',
                                                fontWeight: '600',
                                                color: item.color,
                                            }}
                                        >
                                            {item.name}
                                        </div>
                                    )
                                })}
                            </div>
                            <div
                                className="top-divs-wrapper"
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'space-around',
                                    paddingBottom: '.5vw',
                                    width: '12vw',
                                }}
                            >
                                <BackgroundColorDivs data={topCurrentList} />
                            </div>

                            <div
                                style={{
                                    display: 'flex',
                                    paddingTop: '.5vw',
                                    flexDirection: 'column',
                                    height: '167vw',
                                }}
                            >
                                <KeywordDivs data={bottomDivList} />
                            </div>
                            <div
                                style={{
                                    fontSize: '1.2vw',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    height: '167vw',
                                    position: 'absolute',
                                    top: '-2.5vw',
                                    width: '100%',
                                    right: '0',
                                }}
                            >
                                {bottomNameList.map((item, index) => {
                                    return (
                                        <div
                                            style={{
                                                textAlign: 'end',
                                                fontWeight: '600',
                                                fontSize: '2.2vw',
                                                lineHeight: '2.5vw',
                                                flex: 1,
                                            }}
                                        >
                                            <div style={{ marginTop: '-0.2vw' }}>
                                                {item.position}
                                                <span
                                                    style={{
                                                        marginLeft: '1vw',
                                                        fontSize: '1.6vw',
                                                        fontWeight: '400',
                                                        wordWrap: 'break-word',
                                                        color: '#919499',
                                                    }}
                                                >
                                                    {item.num}
                                                </span>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default FirstPage
